import {
  IsArray,
  IsBoolean,
  IsInt,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsPositive,
  IsString,
  Matches,
} from 'class-validator'
import { PHONE_REGEX } from '../constants'

export class SaveHarvestTeam {
  @IsString()
  @IsNotEmpty()
  name!: string

  @IsNumber()
  @IsPositive()
  @IsInt()
  harvesterId!: number

  @IsArray()
  @IsNumber({}, { each: true })
  cropTypeIds: number[] = []

  @IsNumber()
  @IsPositive()
  @IsInt()
  factoryId!: number

  @IsBoolean()
  isActive!: boolean

  @IsNumber()
  @IsPositive()
  cadence!: number

  @IsString()
  @IsNotEmpty()
  cadenceUnit!: string

  @IsNumber()
  @IsPositive()
  speed!: number

  @IsString()
  @IsNotEmpty()
  speedUnit!: string

  @IsString()
  @IsNotEmpty()
  @IsOptional()
  @Matches(PHONE_REGEX)
  phoneNumber?: string
}
